import React from 'react';

import useRequest from 'utils/useRequest';
import Loading from 'utils/Loading';
import Error from 'utils/Error';
import Article from 'components/Article';

const Resources = () => {
  const { data, loading, error } = useRequest({
    url: 'resources',
    method: 'GET',
  });

  if (loading) {
    return <Loading />;
  }

  if (error || !data) {
    return <Error />;
  }

  return <Article article={data} />;
};

export default Resources;
